var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsString, } from 'class-validator';
import { TransformBoolean } from '../../../decorators';
import { D2CDiscountCodeDiscountType } from '../../../enums';
import { PartialType } from '../../../utils';
import { GetManyQueryDto } from '../../common';
export class GetManyD2CDiscountCodeQueryDto extends PartialType(GetManyQueryDto) {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CDiscountCodeQueryDto.prototype, "code", void 0);
__decorate([
    IsEnum(D2CDiscountCodeDiscountType),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CDiscountCodeQueryDto.prototype, "discountType", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyD2CDiscountCodeQueryDto.prototype, "discountValue", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyD2CDiscountCodeQueryDto.prototype, "maxDiscountAmount", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], GetManyD2CDiscountCodeQueryDto.prototype, "minOrderAmount", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyD2CDiscountCodeQueryDto.prototype, "excludeSpecialContractFromDiscount", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyD2CDiscountCodeQueryDto.prototype, "isActive", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetManyD2CDiscountCodeQueryDto.prototype, "isCompanyIssued", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CDiscountCodeQueryDto.prototype, "startDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], GetManyD2CDiscountCodeQueryDto.prototype, "endDate", void 0);
